import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import {WithdrawActivationAmountComponent} from '../withdraw-activation-amount/withdraw-activation-amount.component';
import {TransactionHistoryComponent} from './transaction-history.component';

const routes: Routes = [
  {
    path: 'transaction-history',
    component: TransactionHistoryComponent,
    data: {animation: 'transaction-history'}
  }
];

@NgModule({
  imports: [RouterModule.forChild(routes)],
  exports: [RouterModule]
})
export class TransactionHistoryRoutingModule { }
